import type { RegionId } from '../types';

export interface DemoStep {
  region: RegionId;
  a: boolean;
  b: boolean;
}

const steps: DemoStep[] = [
  ...(['AND', 'OR', 'NAND'] as RegionId[]).flatMap((region) => [
    { region, a: false, b: false },
    { region, a: false, b: true },
    { region, a: true, b: false },
    { region, a: true, b: true },
  ]),
  { region: 'NOT' as const, a: false, b: false },
  { region: 'NOT' as const, a: true, b: false },
];

export class AutoDemoController {
  private index = 0;
  private elapsed = 0;
  running = false;
  paused = false;

  constructor(private readonly onStep: (step: DemoStep, index: number, total: number) => void) {}

  start(): void {
    this.index = 0;
    this.elapsed = 0;
    this.running = true;
    this.paused = false;
    this.emit();
  }

  togglePause(): void {
    if (this.running) this.paused = !this.paused;
  }

  reset(): void {
    this.running = false;
    this.paused = false;
    this.index = 0;
    this.elapsed = 0;
  }

  update(delta: number): void {
    if (!this.running || this.paused) return;
    this.elapsed += delta;
    if (this.elapsed < 2.3) return;
    this.elapsed = 0;
    this.index += 1;
    if (this.index >= steps.length) {
      this.running = false;
      return;
    }
    this.emit();
  }

  private emit(): void {
    this.onStep(steps[this.index], this.index, steps.length);
  }
}
